import { ISymbolData } from '../parseToTree.types';
import { IGetMissedTagsOptions } from './getMissedTags.types';

const CLOSE_TAGS = ['***', '**', '*', '~~', '_'];

export const getMissedTags = ({
  positionToTag,
}: IGetMissedTagsOptions): Record<number, ISymbolData[]> => {
  const positions = Object.keys(positionToTag);

  if (positions.length === 0) {
    return {};
  }

  const additinalTags: Record<number, string[]> = {};
  const listOfOpenedTags: string[] = [];

  for (let i = 0; i < positions.length; i++) {
    const position = parseInt(positions[i]);
    const tagData = positionToTag[position];

    if (!tagData.tag) {
      continue;
    }

    if (!CLOSE_TAGS.includes(tagData.tag)) {
      continue;
    }

    const openTagIndex = listOfOpenedTags.lastIndexOf(tagData.tag);

    if (openTagIndex === -1) {
      listOfOpenedTags.push(tagData.tag);
      continue;
    }

    if (openTagIndex === listOfOpenedTags.length - 1) {
      listOfOpenedTags.pop();
      continue;
    }

    const notClosedTags = listOfOpenedTags.slice(openTagIndex + 1);

    additinalTags[position] = notClosedTags.slice().reverse();
    additinalTags[position + tagData.tag.length] = notClosedTags;

    listOfOpenedTags.splice(openTagIndex, 1);
  }

  const missedTagsPositions = Object.keys(additinalTags);

  if (missedTagsPositions.length === 0) {
    return {};
  }

  const result: Record<number, ISymbolData[]> = {};

  for (let i = 0; i < missedTagsPositions.length; i++) {
    const position = parseInt(missedTagsPositions[i]);
    const tags = additinalTags[position];

    additinalTags[position] = [];

    for (let j = 0; j < tags.length; j++) {
      const tag = tags[j];

      result[position].push({
        tag,
        start: position,
        end: position + tag.length,
      });
    }
  }

  return result;
};
